import { useTranslation } from "react-i18next";

import { InfoIcon } from "@lucide/icons";

import { RichTextViewer } from "simplydo/react/richtext";
import { styled } from "simplydo/react/styled";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Message } from "simplydo/react/ui/message";

import { FieldProps } from "./FieldProps";

export const InfoTextHeader = styled.div`
  font-size: 9px;
  color: gray;
  text-align: right;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  > h3 {
    margin: 0;
    display: block;
    font-size: 1.5em;
  }
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e9ebee;
`;

type CustomInfoTextProps = { field: FieldProps["field"] };

const CustomInfoText = ({ field }: CustomInfoTextProps) => {
  const { t } = useTranslation();
  return (
    <Message>
      <InfoTextHeader>
        <Icon icon={InfoIcon} color="grey" size="large" />
        <H3>{t("ideas.custom.supporting.info")}</H3>
      </InfoTextHeader>
      <RichTextViewer value={field.content ?? ""} />
    </Message>
  );
};

export default CustomInfoText;
